// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__wIExj","medium":"Badge_medium__kX6Q+","small":"Badge_small__iNkdz","large":"Badge_large__mn0JT"};